<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
    <div
        class="relative w-full max-w-4xl max-h-[90vh] bg-white/95 dark:bg-slate-900/95 border border-slate-100/50 rounded-[2rem] shadow-2xl flex flex-col animate-fade-in-up overflow-hidden">

        <!-- Modal Header -->
        <div
            class="flex items-center justify-between px-8 py-5 border-b border-slate-100/50 bg-white/50 backdrop-blur-md">
            <div>
                <h3 class="text-xl font-extrabold text-slate-800 flex items-center gap-2">
                    <span class="material-icons text-amber-500 text-2xl">edit_document</span>
                    แก้ไขใบกำกับภาษีเต็มรูป
                </h3>
                <p class="text-xs font-semibold text-slate-400 mt-1">
                    แก้ไขรายละเอียดของใบกำกับภาษีเต็มรูป ยกเว้น จำนวนเงิน และ ไอดี
                </p>
            </div>
            <button (click)="closeModal()"
                class="w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 transition-colors flex items-center justify-center shadow-sm hover:scale-105 active:scale-95">
                <span class="material-icons">close</span>
            </button>
        </div>

        <!-- Modal Body -->
        <div class="flex-1 p-8 overflow-y-auto custom-scrollbar" *ngIf="formData">
            <div *ngIf="isReadOnly"
                class="mb-6 flex items-center gap-2 px-4 py-3 rounded-xl bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm font-semibold">
                <span class="material-icons text-base">lock</span>
                ใบกำกับภาษีนี้ยืนยันแล้ว — ไม่สามารถแก้ไขได้
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                <!-- ID (Readonly) -->
                <div class="flex flex-col gap-1.5 md:col-span-1">
                    <label class="text-xs font-bold text-slate-500">รหัสอ้างอิง (ID) <span
                            class="text-amber-500">*อ่านอย่างเดียว</span></label>
                    <input type="text" [value]="formData.id" readonly
                        class="w-full px-4 py-2.5 bg-slate-100 border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-500 outline-none cursor-not-allowed" />
                </div>

                <!-- Receipt ID (Readonly) -->
                <div class="flex flex-col gap-1.5 md:col-span-1">
                    <label class="text-xs font-bold text-slate-500">เลขที่ใบเสร็จ / ใบกำกับภาษี <span
                            class="text-amber-500">*อ่านอย่างเดียว</span></label>
                    <input type="text" [value]="formData.receiptId" readonly
                        class="w-full px-4 py-2.5 bg-slate-100 border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-500 outline-none cursor-not-allowed" />
                </div>

                <!-- Customer Name -->
                <div class="flex flex-col gap-1.5 md:col-span-2">
                    <label class="text-xs font-bold text-slate-500">ชื่อลูกค้า / บริษัท</label>
                    <input type="text" [(ngModel)]="formData.customerName" [readonly]="isReadOnly"
                        [class.cursor-not-allowed]="isReadOnly" [class.bg-slate-100]="isReadOnly"
                        class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
                </div>

                <!-- Tax ID -->
                <div class="flex flex-col gap-1.5 md:col-span-1">
                    <label class="text-xs font-bold text-slate-500">เลขประจำตัวผู้เสียภาษี</label>
                    <input type="text" [(ngModel)]="formData.taxId" [readonly]="isReadOnly"
                        [class.cursor-not-allowed]="isReadOnly" [class.bg-slate-100]="isReadOnly"
                        class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
                </div>

                <!-- Branch / HQ -->
                <div class="flex flex-col gap-1.5 md:col-span-1">
                    <label class="text-xs font-bold text-slate-500">สาขา / สำนักงานใหญ่</label>
                    <div class="flex items-center gap-4 h-[42px]">
                        <label class="flex items-center gap-2 cursor-pointer group">
                            <input type="checkbox" [(ngModel)]="formData.headquarters" [disabled]="isReadOnly"
                                class="w-4 h-4 text-amber-500 border-slate-300 rounded focus:ring-amber-400" />
                            <span
                                class="text-sm font-semibold text-slate-600 group-hover:text-slate-800">สำนักงานใหญ่</span>
                        </label>
                        <input *ngIf="!formData.headquarters" type="text" [(ngModel)]="formData.branchNo"
                            [readonly]="isReadOnly" [class.cursor-not-allowed]="isReadOnly" [class.bg-slate-100]="isReadOnly"
                            placeholder="ระบุสาขา"
                            class="flex-1 px-4 py-2 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
                    </div>
                </div>

                <!-- Address -->
                <div class="flex flex-col gap-1.5 md:col-span-2">
                    <label class="text-xs font-bold text-slate-500">ที่อยู่ (Address)</label>
                    <textarea [(ngModel)]="formData.address" [readonly]="isReadOnly" rows="3"
                        [class.cursor-not-allowed]="isReadOnly" [class.bg-slate-100]="isReadOnly"
                        class="w-full px-4 py-3 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm resize-none"></textarea>
                </div>

                <!-- Contact Info -->
                <div class="flex flex-col gap-1.5 md:col-span-1">
                    <label class="text-xs font-bold text-slate-500">เบอร์โทรศัพท์</label>
                    <input type="text" [(ngModel)]="formData.telephone" [readonly]="isReadOnly"
                        [class.cursor-not-allowed]="isReadOnly" [class.bg-slate-100]="isReadOnly"
                        class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
                </div>

                <div class="flex flex-col gap-1.5 md:col-span-1">
                    <label class="text-xs font-bold text-slate-500">อีเมล (Email)</label>
                    <input type="email" [(ngModel)]="formData.email" [readonly]="isReadOnly"
                        [class.cursor-not-allowed]="isReadOnly" [class.bg-slate-100]="isReadOnly"
                        class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
                </div>

                <!-- Additional Info -->
                <div class="flex flex-col gap-1.5 md:col-span-2">
                    <label class="text-xs font-bold text-slate-500">หมายเหตุ (Remark)</label>
                    <input type="text" [(ngModel)]="formData.remark" [readonly]="isReadOnly"
                        [class.cursor-not-allowed]="isReadOnly" [class.bg-slate-100]="isReadOnly"
                        class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
                </div>

                <!-- Amounts (Readonly Section) -->
                <div
                    class="md:col-span-2 mt-4 p-5 bg-amber-50/50 border border-amber-100 rounded-2xl flex flex-col gap-4">
                    <h4 class="text-sm font-bold text-amber-800 border-b border-amber-200 pb-2">
                        ข้อมูลจำนวนเงิน <span class="text-xs font-semibold text-amber-600 ml-2">(*อ่านอย่างเดียว
                            ไม่สามารถแก้ไขได้)</span>
                    </h4>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <div>
                            <label class="text-[11px] font-bold text-amber-600/70 uppercase">มูลค่าสินค้า/บริการ
                                (Fee)</label>
                            <div class="text-lg font-black text-amber-900 mt-1">{{ formData.fee | number:'1.2-2' }}
                            </div>
                        </div>
                        <div>
                            <label class="text-[11px] font-bold text-amber-600/70 uppercase">ภาษีมูลค่าเพิ่ม (VAT
                                {{ vatSetting.rateLabel() }}%)</label>
                            <div class="text-lg font-black text-amber-900 mt-1">{{ formData.vat | number:'1.2-2' }}
                            </div>
                        </div>
                        <div>
                            <label class="text-[11px] font-bold text-amber-600/70 uppercase">จำนวนเงินรวมทั้งสิ้น
                                (Total)</label>
                            <div class="text-xl font-black text-amber-600 mt-1">{{ formData.total | number:'1.2-2' }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Modal Footer Actions -->
        <div
            class="px-8 py-5 border-t border-slate-100/50 flex items-center justify-between gap-3 bg-slate-50/50 backdrop-blur-sm rounded-b-[2rem]">
            <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isLoading"
                class="px-5 py-2.5 border border-slate-200 hover:border-amber-400 hover:text-amber-600 text-sm font-bold text-slate-600 rounded-xl transition-colors shadow-sm disabled:opacity-50 inline-flex items-center gap-1.5 cursor-pointer">
                <span class="material-icons text-base">history</span>
                ดูประวัติ
            </button>
            <div class="flex items-center justify-end gap-3 ml-auto">
                <button (click)="closeModal()" [disabled]="isLoading"
                    class="px-6 py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-sm font-bold text-slate-600 rounded-xl transition-colors shadow-sm disabled:opacity-50">
                    ยกเลิก
                </button>
                <button (click)="saveData()" [disabled]="isLoading || !formData || isReadOnly"
                    class="flex items-center gap-2 px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-sm font-bold text-slate-900 rounded-xl transition-all shadow-md hover:shadow-lg disabled:opacity-50">
                    <span class="material-icons text-sm" *ngIf="!isLoading">save</span>
                    <span class="material-icons text-sm animate-spin" *ngIf="isLoading">autorenew</span>
                    บันทึกข้อมูล
                </button>
            </div>
        </div>
    </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && invoiceId"
  [entityType]="activityEntityTypes.FullTaxInvoice"
  [entityId]="invoiceId"
  title="ประวัติใบกำกับภาษีเต็มรูป"
  [subtitle]="'#' + invoiceId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<!-- MUST be at the very bottom OUTSIDE the main wrapper per standards -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>